import { z } from 'zod'
import typeguard from '../typeguard'


/** Zone 1 - Innerhalb der EU */                                             type zone1 = 1;
/** Zone 2 - Schweiz & Großbritannien */                                     type zone2 = 2;
/** Zone 3 - Restliches Europa */                                            type zone3 = 3;
/** Zone 4 - Russische Föderation */                                         type zone4 = 4;
/** Zone 5 - USA  */                                                         type zone5 = 5;
/** Zone 6 - Nordafrikanische Gebiete, Kanada, Naher Osten, Teile Asiens  */ type zone6 = 6;
/** Zone 7 - China */                                                        type zone7 = 7;
/** Zone 8 - Restliche Welt  */                                              type zone8 = 8;


const countrySchema = z.object({
  id: z.number(),
  iso: z.string(),
  name: z.string(),
  eu: z.boolean(),
  DhlZone: z.union([
    z.literal<zone1>(1),
    z.literal<zone2>(2),
    z.literal<zone3>(3),
    z.literal<zone4>(4),
    z.literal<zone5>(5),
    z.literal<zone6>(6),
    z.literal<zone7>(7),
    z.literal<zone8>(8),
  ]),
  mwst: z.number().optional(),
})
export type tCountry = z.infer<typeof countrySchema>


const countriesSchema = z.array(countrySchema)
export type tCountries = z.infer<typeof countriesSchema>
export const isCountries = typeguard<tCountries>(countriesSchema)